import React from 'react'

import Button from '@material-ui/core/Button'
import Popover from '@material-ui/core/Popover'
import PaletteIcon from '@material-ui/icons/PaletteOutlined'
import PropTypes from 'prop-types'
import { TwitterPicker } from 'react-color'

// Colour palette taken from CirclePicker in react-color
export const colours = ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']

/**
 * Calculate brightness value by RGB or HEX color.
 * From: https://gist.github.com/w3core/e3d9b5b6d69a3ba8671cc84714cca8a4#gistcomment-3125287
 *
 * @param colour (String) The color value in RGB or HEX (for example: #000000 || #000 || rgb(0,0,0) || rgba(0,0,0,0))
 * @returns (Number) The brightness value (dark) 0 ... 255 (light)
 */
export const brightnessByColour = (colour) => {
  colour = '' + colour
  const isHEX = colour.indexOf('#') === 0
  const isRGB = colour.indexOf('rgb') === 0
  let m, r, g, b
  if (isHEX) {
    const hasFullSpec = colour.length === 7
    m = colour.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g)
    if (m) {
      r = parseInt(m[0] + (hasFullSpec ? '' : m[0]), 16)
      g = parseInt(m[1] + (hasFullSpec ? '' : m[1]), 16)
      b = parseInt(m[2] + (hasFullSpec ? '' : m[2]), 16)
    }
  }
  if (isRGB) {
    m = colour.match(/(\d+){3}/g)
    if (m) {
      r = m[0]
      g = m[1]
      b = m[2]
    }
  }
  if (typeof r !== 'undefined') {
    return ((r * 299) + (g * 587) + (b * 114)) / 1000
  } else {
    return 0
  }
}

class ColourPicker extends React.Component {
  constructor () {
    super()

    this.state = {
      anchorEl: null,
      show: false
    }
  }

  handleChange = (colourObj, evt) => {
    const { onChange } = this.props

    // Return the hex value of the new colour to the parent
    if (typeof onChange === 'function') {
      onChange(colourObj.hex)
    }

    // Close popup when user has clicked on a colour but not when they change it in other ways
    if (evt.type === 'click') {
      this.handleClose()
    }
  }

  handleClick = (event) => {
    this.state.show ? this.handleClose(event) : this.handleShow(event)
  }

  handleShow = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      show: true
    })
  }

  handleClose = (event) => {
    this.setState({
      anchorEl: null,
      show: false
    })
  }

  render () {
    const { colour } = this.props

    // For accessibility
    const colourPickerId = this.state.anchorEl ? 'colour-picker-popover' : undefined

    // Make sure colour picker icon is always readable
    const paletteIconColour = brightnessByColour(colour) > 200 ? 'black' : 'white'

    return (
      <React.Fragment>
        <Button style={{ backgroundColor: colour, padding: 0, minWidth: 36 }} aria-describedby={colourPickerId} variant="outlined" onClick={this.handleClick}>
          <PaletteIcon style={{ color: paletteIconColour }} />
        </Button>
        <Popover
          id={colourPickerId}
          open={this.state.show }
          anchorEl={() => this.state.anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <TwitterPicker color={colour} colors={colours} onChange={ this.handleChange } />
        </Popover>
      </React.Fragment>
    )
  }
}

ColourPicker.propTypes = {
  colour: PropTypes.string.isRequired,
  onChange: PropTypes.func
}

export default ColourPicker
